import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';



const KillTeamCampaign = () => {
  const navigate = useNavigate();

  return (
    <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
      {/* Back button */}
      <button
        onClick={() => navigate("/projects")}
        style={{
          position: "absolute",
          top: 12,
          left: 12,
          zIndex: 1000,
          padding: "8px 12px",
          cursor: "pointer",
          background: "#2a2a2a",
          border: "1px solid #444",
          color: "white",
          fontFamily: "sans-serif"
        }}
      >
        Back
      </button>

      {/* Render your HTML page */}
      <iframe
        src="/games/KillTeamCampaign/KillTeamCampaign.html"
        title="Kill Team Campaign"
        style={{
          width: "100%",
          height: "100%",
          border: "none"
        }}
      />
    </div>
  );
};

export default KillTeamCampaign;